import React, { useMemo } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
  createColumnHelper,
} from "@tanstack/react-table";

const SpareSalesDropDownTable = ({ data }) => {
  const columnHelper = createColumnHelper();

  const columns = useMemo(
    () => [
      columnHelper.accessor("dealer_name", {
        header: "Dealer Name",
        cell: (info) =>
          info.getValue() ? info.getValue() : <span className="text-red-500">Missing</span>,
      }),
      columnHelper.accessor("division", {
        header: "Division",
        cell: (info) => info.getValue() || <span className="text-gray-400">N/A</span>,
      }),
      columnHelper.accessor("channel_partner_type", {
        header: "Partner Type",
        cell: (info) => info.getValue(),
      }),
      columnHelper.accessor("part_no", {
        header: "Part No",
        cell: (info) =>
          /^[0-9A-Za-z]+$/.test(info.getValue())
            ? info.getValue()
            : <span className="text-red-500">Invalid</span>,
      }),
      columnHelper.accessor("part_desc", {
        header: "Part Description",
        cell: (info) => info.getValue(),
      }),
      columnHelper.accessor("sum_of_quantity", {
        header: "Quantity",
        cell: (info) =>
          info.getValue() > 0 ? info.getValue() : <span className="text-red-500">0 (Invalid)</span>,
      }),
      columnHelper.accessor("total_amount", {
        header: "Total Amount (in lakhs)",
        cell: (info) => (info.getValue() >= 0 ? info.getValue().toFixed(4) : "Invalid"),
      }),
      columnHelper.accessor("chssis_no", {
        header: "Chassis No",
        cell: (info) =>
          info.getValue()?.length === 17 ? info.getValue() : <span className="text-red-500">Invalid</span>,
      }),
    ],
    []
  );

  const table = useReactTable({
    data: data || [],
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  if (!data || data.length === 0) {
    return <div className="p-4 text-gray-500">No data available</div>;
  }

  // Estimate row height (adjust if needed)
  const rowHeight = 40; // approx px per row
  const maxVisibleRows = 10;
  const maxHeight = rowHeight * maxVisibleRows;

  return (
    <div className="p-4">
      <div className="overflow-auto border border-gray-300 rounded" style={{ maxHeight }}>
        <table className="border-collapse w-full">
          <thead className="bg-gray-200 sticky top-0">
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    className="border border-gray-300 px-2 py-1 text-left bg-[#2374BF] text-white"
                  >
                    {flexRender(header.column.columnDef.header, header.getContext())}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row) => (
              <tr key={row.id} className="hover:bg-gray-100">
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id} className="border border-gray-300 px-2 py-1">
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SpareSalesDropDownTable;
